// components/GlobalAddPopup.js
import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import AddPopup from './Popup/AddPopup/AddPopup';
import { AddPopupContext } from '../context/AddPopupContext';
import AddUserRolePopup from './Popup/AddPopup/AddInternalUserRoles';


const GlobalAddPopup = () => {
  const {
    isNewPopupOpen,
    currentConfig,
    closePopup,
    handleSave,
    handleSaveUserRole,
    popupError
  } = useContext(AddPopupContext);

  // console.log('GlobalAddPopup render:', { isNewPopupOpen, currentConfig });

  if (!isNewPopupOpen || !currentConfig) {
    return null;
  }

  if (currentConfig.useCustomPopup === 'AddUserRolePopup') {
    return (
      <AddUserRolePopup
        isOpen={isNewPopupOpen}
        title={currentConfig.title}
        buttonName={currentConfig.buttonName}
        fields={currentConfig.fields}
        onSave={(formData) => {
          handleSaveUserRole(formData, currentConfig.endpoint);
        }}
        onClose={closePopup}
        initialTableRows={currentConfig.customPopupProps.initialTableRows}
        popupErrorMessage={currentConfig.errorMessage}
      />
    );
  }

  return (
    <AddPopup
      isOpen={isNewPopupOpen}
      title={currentConfig.title}
      buttonName={currentConfig.buttonName}
      fields={currentConfig.fields}
      onSave={handleSave}
      onClose={closePopup}
      popupErrorMessage={popupError}
    />
  );
};


export default GlobalAddPopup;